import styled, { css } from 'styled-components'

export const Container = styled.button`
  all: unset;

  min-width: ${({ $width }) => ($width ? `${$width}px` : '38px')};
  min-height: ${({ $height }) => ($height ? `${$height}px` : '38px')};

  border-radius: 4px;
  background: ${({ color }) => color};

  display: flex;
  align-items: center;
  justify-content: center;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.7;
      cursor: not-allowed;
    `}

  svg {
    fill: white;
  }

  &:hover {
    background: ${({ color }) => color};
  }
`
